export const PAGE_PATH = '/admin-event';
